import authorizedRequest from 'api/request/authorizedRequest';
import { PREFIX_API } from 'constants/api.const';
import { preprocessGetQuery } from 'helpers/api.helper';
import { getFormData } from 'helpers/form-data.helper';
import {
  ActivePhotoAlbumRequestModel,
  ActivePhotoAlbumResponseModel,
  DeletePhotoAlbumRequestModel,
  DeletePhotoAlbumResponseModel,
  GetPhotoAlbumRequestModel,
  GetPhotoAlbumResponseModel,
  InactivePhotoAlbumRequestModel,
  InactivePhotoAlbumResponseModel,
  ListPhotoAlbumRequestModel,
  ListPhotoAlbumResponseModel,
  SavePhotoAlbumRequestModel,
  SavePhotoAlbumResponseModel,
} from 'models/setting/photo-album.model';

export function getPhotoAlbum(payload: GetPhotoAlbumRequestModel) {
  if (payload?.id) {
    return authorizedRequest.get<
      GetPhotoAlbumResponseModel,
      GetPhotoAlbumResponseModel
    >(`${PREFIX_API.GENERAL}/albums/${payload?.id}`);
  }
}

export function listPhotoAlbum(payload: ListPhotoAlbumRequestModel) {
  return authorizedRequest.get<
    ListPhotoAlbumResponseModel,
    ListPhotoAlbumResponseModel
  >(`${PREFIX_API.GENERAL}/albums?${preprocessGetQuery(payload)}`);
}

export function createPhotoAlbum(payload: SavePhotoAlbumRequestModel) {
  const formDataPayload = getFormData(payload);

  return authorizedRequest.post<
    SavePhotoAlbumResponseModel,
    SavePhotoAlbumResponseModel
  >(`${PREFIX_API.GENERAL}/albums`, formDataPayload, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function updatePhotoAlbum(payload: SavePhotoAlbumRequestModel) {
  if (payload?.id) {
    const formDataPayload = getFormData(payload);

    return authorizedRequest.put<
      SavePhotoAlbumResponseModel,
      SavePhotoAlbumResponseModel
    >(`${PREFIX_API.GENERAL}/albums/${payload?.id}`, formDataPayload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export function deletePhotoAlbum(payload: DeletePhotoAlbumRequestModel) {
  return authorizedRequest.delete<
    DeletePhotoAlbumResponseModel,
    DeletePhotoAlbumResponseModel
  >(`${PREFIX_API.GENERAL}/albums/${payload?.id}`);
}

export function inactivePhotoAlbum(payload: InactivePhotoAlbumRequestModel) {
  return authorizedRequest.put<
    InactivePhotoAlbumResponseModel,
    InactivePhotoAlbumResponseModel
  >(
    `${PREFIX_API.GENERAL}/albums/${payload?.id}/inactive?${preprocessGetQuery(
      payload,
    )}`,
    payload,
  );
}

export function activePhotoAlbum(payload: ActivePhotoAlbumRequestModel) {
  return authorizedRequest.put<
    ActivePhotoAlbumResponseModel,
    ActivePhotoAlbumResponseModel
  >(
    `${PREFIX_API.GENERAL}/albums/${payload?.id}/active?${preprocessGetQuery(
      payload,
    )}`,
    payload,
  );
}
